import axios from 'axios'
import router from '../router'
import { config } from '../constant/config'

// 创建axios实例
const service = axios.create({
  baseURL: config.BASE_URL, // api的base_url
  timeout: 60 * 1000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (localStorage.getItem('token')) {
    config.headers['Authorization'] = localStorage.getItem('token')
  }
  return config
}, error => {
  console.warn('请求异常' + JSON.stringify(error))
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.headers && response.headers.authorization) {
      localStorage.setItem('token', response.headers.authorization)
    }
    const res = response.data
    if (response.status !== 200 && res.status !== 200) {
      alert(res.msg)
    } else {
      if (res.code === 401) { // token 过期
        localStorage.removeItem('token')
        router.push({
          path: '/login'
        })
      } else {
        return response.data
      }
    }
  },
  error => {
    console.warn('响应异常' + JSON.stringify(error))
    if (error.response.data.code === 401) {
      localStorage.removeItem('token')
      router.push({
        path: '/login'
      })
    } else {
      return Promise.reject(error)
    }
  }
)
export default service
